import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchProjectsIfNeeded } from 'data/actions/projects';

import FilterLink from 'components/molecules/filterLink';

class filterLinkContainer extends Component {
    componentDidMount() {
        this.props.fetchProjectsIfNeeded();
    }

    componentDidUpdate(prevProps, prevState) {}

    render() {
        return <FilterLink {...this.props} />;
    }
}

function getProjectCount(projects, category) {
    // Return all projects if the category title is `All work`
    if (category === 'All work') {
        return projects.length;
    }

    return projects.reduce(
        (n, x) => n + (x.fields.category.fields.title === category),
        0
    );
}

const mapStateToProps = (state, ownProps) => {
    const projects = state.projects.all;
    const category = ownProps.title;
    const url = ownProps.slug === '' ? '/' : `/filter/${ownProps.slug}`;
    const count = getProjectCount(projects, category);

    return {
        title: category,
        url,
        count
    };
};

filterLinkContainer = withRouter(
    connect(mapStateToProps, { fetchProjectsIfNeeded })(filterLinkContainer)
);

export default filterLinkContainer;



// WEBPACK FOOTER //
// ./src/data/containers/filterLink.js